/* eslint-disable import/first */
if (process.env.NODE_ENV) {
  // Must be the first import
  import('preact/debug');
} else {
  // Or if you just want the devtools bridge (~240B) without other
  // debug code (useful for production sites)
  import('preact/devtools');
}

import './main.css';
import Layout from './utils/layout';
import Video from './utils/video';

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = new Layout();
  const moduleList = {};

  if (window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const { sectionId } = e.detail;
      const el = e.target.querySelector('[data-section]');
      // eslint-disable-next-line no-console
      console.log('moduleList', moduleList);
      (moduleList[sectionId]
        ? Promise.resolve(moduleList[sectionId].m)
        : import(
            /* webpackChunkName: "[index]" */ `./${el.dataset.section}/index.js`
          )
      ).then((m) => {
        const dataEl = el.querySelector('[data-section-data]');
        const data = dataEl ? JSON.parse(dataEl.textContent) : {};
        const videoEls = el.querySelectorAll('[data-component="video"]');
        const videos =
          videoEls &&
          [...videoEls].map(
            (videoEl) => new Video({ el, video: videoEl, layout }),
          );
        m?.default(el, { ...data, layout, videos });
      });
    });
  }

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        const modules = [...sections].filter(
          (section) => section.dataset.section === name,
        );
        modules.forEach((element) => {
          const { sectionId } = element.dataset;
          const dataEl = element.querySelector('[data-section-data]');
          const data = dataEl ? JSON.parse(dataEl.textContent) : {};
          const videoEls = element.querySelectorAll('[data-component="video"]');
          const videos =
            videoEls &&
            [...videoEls].map(
              (videoEl) => new Video({ element, video: videoEl, layout }),
            );
          moduleList[sectionId] = {
            m,
            data,
            videos,
          };
          module(element, { ...data, layout, videos });
        });
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  });

  const openPanel = (e, target, bodyEl) => {
    if (!target) return;
    const targetEl = target.dataset.container;
    const container = document.querySelector(`[data-${targetEl}]`);
    const chatLauncher = document
      .getElementById('launcher')
      ?.parentElement?.closest('div');
    bodyEl.classList.add('disable-scroll');
    container.classList.add('panel-active');
    chatLauncher.style.display = 'none';
  };

  const closePanel = (el, bodyEl) => {
    const target = document.querySelectorAll('[data-panel]');
    const chatLauncher = document
      .getElementById('launcher')
      ?.parentElement?.closest('div');
    if (!target.length) return;
    target.forEach((el) => {
      el.classList.remove('panel-active');
    });
    bodyEl.classList.remove('disable-scroll');
    chatLauncher.style.display = 'block';
  };

  const panelInit = () => {
    const bodyEl = document.querySelector('body');
    document.querySelectorAll('[data-panel-open]').forEach((el) => {
      el.addEventListener('click', (e) => {
        const target = el;
        openPanel(e, target, bodyEl);
      });
    });

    const closingPanelEls = document.querySelectorAll('[data-panel-close]');

    document
      .querySelector('.backdrop-overlay')
      ?.addEventListener('click', (e) => {
        closePanel(e.target, bodyEl);
      });

    if (!closingPanelEls.length) return;

    closingPanelEls.forEach((el) => {
      el.addEventListener('click', () => {
        closePanel(el, bodyEl);
      });
    });
  };

  panelInit();
})();
